import React from "react";
import { useTranslation } from "react-i18next";
import FormatDate from "go-core/components/Formatters/FormatDate";
import FormatMoney from "go-core/components/Formatters/FormatMoney";
import { OrganizationProductApi } from "../../../../../../../services/Api/types";

interface Props {
	product: OrganizationProductApi;
	currency: string;
}

const OrganizationProductCategoryProduct = ({ product, currency }: Props) => {
	const { t } = useTranslation("admin");

	const getCardBackgroundColor = () => {
		if (product.subscription_value) return "#DFF9E4";
		if (!product.subscription_value) return "#E9ECEF";
		return "#FEE6E5";
	};

	const getCardFontColor = () => {
		if (product.subscription_value) return "#28A745";
		if (!product.subscription_value) return "#6C757D";
		return "#DC3545";
	};

	const getPoints = () => {
		return `${product.points ?? 0}/${product.possible_points ?? 0}`;
	};

	return (
		<div className="d-flex align-items-center justify-content-between organization-product-category-product">
			<div className="d-flex align-items-center gap-2">
				<div style={{ backgroundColor: getCardBackgroundColor() }} className="product-points">
					<p className="mb-1" style={{ color: getCardFontColor() }}>{`${getPoints()} ${t(
						"modules.organization.field.points_shortcut.title"
					).toLowerCase()}`}</p>
					<p className="mb-0" style={{ color: getCardFontColor() }}>{`${product.mrr ?? 0} MRR`}</p>
				</div>
				<div className="d-flex flex-column gap-1">
					<h5 className="mb-0">{product.name}</h5>
					<small className="text-muted">
						{t("modules.organization.field.used.title")}:
						{product.last_used_at
							? FormatDate(product.last_used_at)
							: t("modules.organization.field.lack.title")}
					</small>
					<small className="text-muted">
						{t("common.word.partner")}:
						<strong className="ms-1">
							{product.partner?.name ?? t("modules.organization.field.lack.title")}
						</strong>
					</small>
				</div>
			</div>
			<div className="d-flex flex-column">
				<h5 className="mb-0">{`LTV: ${FormatMoney({ amount: product.lifetime_value, currency })}`}</h5>
			</div>
		</div>
	);
};

export default OrganizationProductCategoryProduct;
